<template>
  <div class="controlItemWrapper" :class="control.className" :data-control-name="control.name">
    <div class="controlItem row" :id="control.name" v-if="labelPosition === 'left'">
      <div class="col-md-4">
        <label
          :class="{'bold': control.labelBold, 'italic': control.labelItalic, 'underline': control.labelUnderline}"
        >{{control.label}}</label>
      </div>
      <div class="col-md-8">
        <b-input-group v-if="!control.readonly">
          <b-input-group-prepend class="toggle-wrapper" is-text>
            <button class="toggle-calendar" type="button" title="Toggle" data-toggle>
              <icon name="calendar" />
            </button>
          </b-input-group-prepend>
          <flat-pickr
            :config="{
              wrap: true,
              allowInput: true,
              formatDate: formatDate
            }"
            v-model="value"
            class="form-control datepicker"
          />
        </b-input-group>
      </div>
    </div>
    <div class="controlItem row" :id="control.name" v-else>
      <div class="form-group col-md-12">
        <label
          :class="{'bold': control.labelBold, 'italic': control.labelItalic, 'underline': control.labelUnderline}"
        >{{control.label}}</label>
        <flat-pickr
          v-if="!control.readonly"
          :config="{
            allowInput: false,
            formatDate: formatDate
          }"
          v-model="value"
          class="form-control datepicker"
        />
        <b-form-input v-else :disabled="true" />
      </div>
    </div>
  </div>
</template>

<script>
import { CONTROL_TYPES } from "@/components/DataGrid/FormBuilder/config/control_constant";
import { CONTROL_CONSTANTS } from "@/components/DataGrid/FormBuilder/config/constants";
// helpers
import utils from '@/helpers/utils'

export default {
  name: "DatePickerControl",
  props: ["control", "labelPosition"],
  data () {
    return {
      value: Date.now()
    }
  },
  methods: {
    formatDate: utils.formatDate
  }
};
</script>

<style scoped>
.toggle-calendar {
  padding: 0;
  border: 0;
  margin: 0;
  background: none;
}
.toggle-wrapper {
  height: 46px;
}
</style>